if (!customElements.get('star-account-menu')) {
  customElements.define('star-account-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.querySelector('.star-account-menu__trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog || !this.dialog.showModal) return;
      this.trigger.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.position();
      }, options);
      this.querySelector('.star-account-menu__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
      window.addEventListener('resize', () => { if (this.dialog.open) this.position(); }, options);
    }
    position() {
      const dialog = this.dialog;
      if (window.innerWidth < 750) {
        dialog.style.removeProperty('left');
        dialog.style.removeProperty('top');
        return;
      }
      const rect = this.trigger.getBoundingClientRect();
      const left = Math.max(16, Math.min(window.innerWidth - dialog.offsetWidth - 16, rect.right - dialog.offsetWidth));
      const top = Math.max(16, Math.min(window.innerHeight - dialog.offsetHeight - 16, rect.bottom + 14));
      dialog.style.left = `${left}px`;
      dialog.style.top = `${top}px`;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
    }
  });
}
